import { Modal, Checkbox } from 'antd';
import React, { Component, useState } from 'react';
import { useEffect } from 'react';

export default function BayDataPivotSelector({ open, onCancel, filters, onChange, selectedKeyDefault = [] }) {
    const [selectedKeys, setSelectedkeys] = useState(selectedKeyDefault);

    const HandleCheckChange = (e, filter) => {
        console.log(filter, e?.target?.checked);
        setSelectedkeys(prev => {
            if (e?.target?.checked == true) {
                prev.push(filter);
                console.log(prev);
                return prev;
            } else {
                return prev.filter(d => d != filter);
            }
        });
    };

    useEffect(() => {
        console.log('useEffect', { selectedKeys });
    }, [selectedKeys]);

    return (
        <>
            <Modal open={open} onCancel={onCancel} okText="Save" onOk={() => onChange(selectedKeys)}>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                    }}
                >
                    {Object.keys(filters)?.map(filter => {
                        return (
                            <Checkbox defaultChecked={selectedKeys?.findIndex(d => d == filter) > -1} onClick={e => HandleCheckChange(e, filter)}>
                                {filter}
                            </Checkbox>
                        );
                    })}
                </div>
            </Modal>
        </>
    );
}
